import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@/utils/auth'
import VehicleVersionsPage from '@/components/Vehicle/VehicleVersionsPage'

export const Route = createFileRoute('/vehicle-versions')({
  beforeLoad: () => requirePermission('vehicle_administration', 'write'),
  component: VehicleVersionsPage,
})
